// Environment configuration
const isDevelopment = process.env.NODE_ENV === 'development';
const isProduction = process.env.NODE_ENV === 'production';

export const config = {
  // Development features (only available in dev)
  development: {
    showAdminPanel: true,
    showDebugInfo: true,
    enableConsoleLogs: true,
  },
  
  // Production features (what visitors see)
  production: {
    showAdminPanel: false,
    showDebugInfo: false,
    enableConsoleLogs: false,
  },
  
  // Current environment
  current: isDevelopment ? 'development' : 'production',
  
  // Helper functions
  isDevelopment,
  isProduction,
  
  // Get config for current environment
  get: (key) => {
    const env = isDevelopment ? 'development' : 'production';
    return config[env][key];
  }
};

export default config;
